import { ReactNode, memo } from 'react';
import * as styles from './CommentCard.css';
import { useTimeAgo } from 'hooks/useTimeAgo';
import { toast } from 'react-toastify';
import { Box, Button, Card, Stack } from '@ff-it/ui';
import { UserAvatar } from 'components/UserAvatar';
import { useAnchorUrl } from './useNavigationState';
import { Comment } from './types';
import { RichTextRenderer } from 'components/RichText';
import { getUserTitle } from 'modules/core/helpers';

type CommentCardProps = { item: Comment; selected?: boolean };

export const CommentCard = memo(
  function CommentyCard({
    item: { id, content, created_by: author, created_at },
    selected,
  }: CommentCardProps): ReactNode {
    const anchorUrl = useAnchorUrl(id);
    const timeAgo = useTimeAgo(created_at);
    return (
      <Card data-comment-id={id} active={selected} className={styles.card} flexShrink={0} aria-selected={selected}>
        <Stack direction="horizontal" align="center">
          <UserAvatar user={author} size="xs" />
          <div className={styles.name}>{getUserTitle(author)}</div>
          <div className={styles.timeAgo}>{timeAgo}</div>
          <div className={styles.controls}>
            <Button
              icon="ellipsis"
              size="xxs"
              variant="ghost"
              onClick={() => {
                navigator.clipboard.writeText(anchorUrl);
                toast.info('Link copied to clipboard');
              }}
            />
          </div>
        </Stack>
        <Box textSize="sm">
          <RichTextRenderer value={content} />
        </Box>

        {/* footer */}
      </Card>
    );
  },
  (prevProps, nextProps) => {
    // @TODO last activity or deeep euqal?
    return prevProps.item.id === nextProps.item.id;
  },
);
